// components
import { Navbar, Footer } from "@/components";

// sections
import Faq from "../../faq";
import OurPrograms from "../../our-programs";
import { Link } from "react-router-dom";
import CarouselFeatures from "@/app/carousel-features";
import { CalendlyWidget } from "@/components/widget";

const TraithlonTrainings = () => {
  return (
    <section className="mb-20 container text-center md:text-left mt-6 md:mt-10 mx-auto px-6">
      <h1 className="mb-8 text-center text-4xl font-bold">
        Triathlon Trainings
      </h1>

      <p className="mb-6">
        Today, staying healthy and fit is really important. Some people use apps
        like TrainingPeaks to help them with their workouts. These apps are easy
        to use and give you a general plan to follow. But they don't give you
        the same personal attention as a real trainer. That's why having your
        own customized workout plan is better than using one from TrainingPeaks.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/tri_1.webp`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <h2 className="mb-4 text-3xl font-bold">
        Personalized Coaching and Training{" "}
      </h2>

      <p className="mb-6">
        Triathlon is not just about being a good swimmer, cyclist, or runner;
        it's about excelling in all three disciplines simultaneously. This
        requires a unique approach to training, one that balances the demands of
        each sport while considering your personal strengths and areas for
        improvement. A personal trainer with expertise in triathlon training
        offers invaluable guidance in this regard. They'll assess your current
        level in each discipline and develop a tailored training program that
        optimizes your performance across swimming, cycling, and running.
      </p>

      <p
        style={{ borderColor: "red" }}
        className="mb-6 rounded border-l-4 bg-green p-2"
      >
        <strong>Note:</strong> At NRC Team we are offering an individual and
        flexible options, which will be suitable for everyone. Find more about
        what we{" "}
        <Link
          style={{ textDecoration: "underline", fontWeight: "bold" }}
          to="/coaching"
        >
          offer
        </Link>{" "}
        and start your journey today.
      </p>

      <p className="mb-6">
        Personal trainers also bring a wealth of knowledge about technique,
        which is crucial for efficiency and injury prevention. They can correct
        your swimming stroke, optimize your cycling posture, and improve your
        running gait. This detailed attention to technique not only enhances
        performance but also reduces the risk of overuse injuries, which are
        common in multi-sport athletes.
      </p>
      <p className="mb-6">
        Moreover, your trainer will adapt your training plan as you progress,
        ensuring that you're continually challenged and improving. This dynamic
        approach keeps training fresh and engaging, helping you stay motivated
        and focused on your goals.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/tri_2.webp`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <h2 className="mb-4 text-3xl font-bold">Motivation and Accountability</h2>

      <p className="mb-6">
        One of the biggest challenges in any training regimen is staying
        motivated and accountable. This is where a personal trainer becomes an
        indispensable ally. They provide the encouragement and support you need
        to push through tough days and celebrate your victories on good ones.
        Knowing that someone is tracking your progress and is as invested in
        your success as you are can be a powerful motivator.
      </p>
      <p className="mb-6">
        Your trainer will set realistic, incremental goals that lead up to your
        main objective – completing a triathlon. These smaller goals provide
        short-term targets to aim for, keeping your training on track and giving
        you a sense of achievement as you tick each one off. This structured
        approach helps maintain a high level of motivation and commitment.
      </p>
      <p className="mb-6">
        Furthermore, the regular training sessions with your trainer create a
        routine and add a layer of accountability. It's easier to skip a workout
        when you're on your own, but knowing your trainer is waiting for you can
        be just the push you need to get out the door.
      </p>

      <h2 className="mb-4 text-3xl font-bold">
        Complete Training and Wellness Method
      </h2>

      <p className="mb-6">
        Triathlon training is more than just physical preparation; it's a
        holistic endeavor that includes nutrition, recovery, and mental
        strength. A personal trainer understands this and will help you navigate
        these often-overlooked aspects of training.
      </p>
      <p className="mb-6">
        Nutrition plays a critical role in performance and recovery. Your
        trainer can provide guidance on how to fuel your body for endurance
        training, ensuring you're getting the right balance of nutrients to
        support your training and recovery.
      </p>
      <p className="mb-6">
        Recovery is another critical component of triathlon training. Your
        trainer will educate you on effective recovery techniques, such as
        active recovery, rest days, and stretching, to help your body repair and
        strengthen.
      </p>
      <p className="mb-6">
        Lastly, mental toughness is key in a demanding sport like triathlon.
        Your trainer will help you develop the mental resilience needed to
        tackle the challenges of training and eventually, the race itself. This
        might include strategies for staying positive, managing stress, and
        visualizing success.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/tri_3.webp`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <p>
        In summary, a personal trainer specialized in triathlons offers more
        than just a training plan. They provide expertise, motivation,
        accountability, and a holistic approach to your overall well-being.
        Whether you're a beginner aiming to complete your first triathlon or an
        experienced athlete looking to improve your performance, a personal
        trainer can be your greatest asset in achieving your goals. Join us, and
        let's embark on this transformative journey together, with expert
        guidance every stroke, pedal, and step of the way.
      </p>
    </section>
  );
};

export default function TriathlonTrainingPage() {
  return (
    <>
      <Navbar />
      <TraithlonTrainings />
      <OurPrograms />
      <CarouselFeatures />
      <CalendlyWidget />
      <Faq />
      <Footer />
    </>
  );
}
